import { render, staticRenderFns } from "./ButtonDropdown.vue?vue&type=template&id=57354e81"
import script from "./ButtonDropdown.vue?vue&type=script&lang=js"
export * from "./ButtonDropdown.vue?vue&type=script&lang=js"
import style0 from "./ButtonDropdown.vue?vue&type=style&index=0&id=57354e81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports